import { render, staticRenderFns } from "./UdefBattleCard.vue?vue&type=template&id=6236528c&scoped=true&"
import script from "./UdefBattleCard.vue?vue&type=script&lang=js&"
export * from "./UdefBattleCard.vue?vue&type=script&lang=js&"
import style0 from "./UdefBattleCard.vue?vue&type=style&index=0&id=6236528c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6236528c",
  null
  
)

export default component.exports